import React, { useState } from 'react';
import ModalComponent from '../../../../../common-components/ModalComponent/ModalComponent';
import '../../../styles/labelling.scss';
import TransparentButton from '../../../../../styledComponents/TransparentButton.style';
import AddIcon from '../../../../../Icons/icons/AddIcon';
import ButtonComponent from '../../../../../common-components/ButtonComponent/ButtonComponent';
import { useSelector } from 'react-redux';
import InputComponent from '../../../../../common-components/InputComponent/InputComponent';
import SaralLoaderImage from '../../../../../common-components/SaralLoaderImage';
import LabelItem from './LabelItem';
import { attachLabel } from '../../../../../../services/postTracking.service';
import { NotificationManager } from 'react-notifications';
import { useCampaignDetail } from '../CampaignDetailProvider';

const AddLabelModal = ({ show, onClose, setActiveModal, setEditLabel, post }) => {
  const { labels, isLoadingLabels } = useSelector((s) => s.socialListening);

  const [selectedLabels, setSelectedLabels] = useState(() => {
    if (post?.labels) return post?.labels?.map((l) => l._id);
    return [];
  });
  const [isLoading, setIsLoading] = useState(false);

  const { clearAllContentFilters } = useCampaignDetail();

  const isLabelPresent = Boolean(labels?.length);

  const toggleLabelSelected = (labelId) => {
    if (selectedLabels.includes(labelId)) {
      setSelectedLabels(() => [...selectedLabels.filter((l) => l !== labelId)]);
    } else {
      setSelectedLabels((e) => [...e, labelId]);
    }
  };

  const renderContent = () => {
    if (isLoadingLabels)
      return (
        <div className="sl-label-loader">
          <SaralLoaderImage />
        </div>
      );
    if (!isLabelPresent) return <NoLabelsFtux onCreateClick={() => setActiveModal('createLabel')} />;
    return (
      <div className="sl-label-list-container">
        {labels?.map((label) => {
          const { _id, color, title } = label;
          return (
            <LabelItem
              checked={selectedLabels.includes(_id)}
              key={_id}
              title={title}
              color={color}
              onEditClick={() => {
                setEditLabel(label);
                setActiveModal('editLabel');
              }}
              onClick={() => toggleLabelSelected(_id)}
            />
          );
        })}
      </div>
    );
  };

  const onAddLabelClick = async () => {
    setIsLoading(true);
    const response = await attachLabel({
      postId: post._id,
      labelIds: selectedLabels,
    });
    setIsLoading(false);
    if (response?.status) {
      clearAllContentFilters();
      onClose();
      NotificationManager.success('Labels Added!', '', 1200);
    } else {
      NotificationManager.error('Error attaching label', '', 1200);
    }
  };

  return (
    <ModalComponent show={show} onClose={() => onClose()} width={450} style={{ padding: 0 }} bodyStyle={{ padding: 0 }} >
      <div className="sl-add-label-container">
        <div className="sl-add-label-header">
          <div style={{ textAlign: isLabelPresent ? 'left' : 'center' }} className="sl-add-label-header-title">
            Add Label
          </div>
          {isLabelPresent ? (
            <TransparentButton
              onClick={() => setActiveModal('createLabel')}
              color="var(--purple-p-400)"
              style={{ fontSize: '18px', padding: 0 }}>
              <AddIcon color="currentColor" />
              Create New
            </TransparentButton>
          ) : (
            <></>
          )}
        </div>
        {renderContent()}
        <div className="sl-add-label-bottom-container">
          <ButtonComponent style={{ flex: 1 }} variant="secondary" onClick={() => onClose()}>
            Cancel
          </ButtonComponent>
          <ButtonComponent
            showLoading={isLoading}
            onClick={() => onAddLabelClick()}
            disabled={!selectedLabels.length || selectedLabels.length > 5}
            style={{ flex: 1 }}>
            Label It!
          </ButtonComponent>
        </div>
      </div>
    </ModalComponent>
  );
};

const NoLabelsFtux = ({ onCreateClick }) => {
  return (
    <div className="sl-no-labels-ftux">
      <InputComponent label="Select a Label" required placeholder="No labels created" readOnly />
      <ButtonComponent onClick={onCreateClick} style={{ flex: 1 }} variant="primary-outline">
        <AddIcon color="currentColor" />
        Create New Label
      </ButtonComponent>
    </div>
  );
};

export default AddLabelModal;
